import structure from "./images/Structure2.jpeg";
import pumpimg from "./images/Pump.png";
import MBFV01 from "./images/MBFV01.png";
import MBFV03 from "./images/MBFV03.png";
import PS101 from "./images/PS101.png";
import SovValve from "./images/SovValve.png";
import { useState, useEffect, useRef } from "react";
import Filtration from "./Filtration";
import EOPD from "./EOPD";
import IntakeSum from "./InTakeSum";
import Motor from "./Motor";
import VaccumPump from "./VaccumPump";
import DischargeLine from "./DischargeLine";
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import psGreen from "./images/psGreen.png";
import psYellow from "./images/psYellow.png";
import psGrey from "./images/psGrey.png";
import GreyValveImg from "./images/GreyValveImg.png";
import YellowValveImg from "./images/YellowValveImg.png";
import SovGreen from "./images/SovGreen.png";
import YellowImage from "./images/YellowPump.png";
import GreyImage from "./images/greyPump.png";
import GreenImage from "./images/greenPump.png";
import RedImage from "./images/Pump.png";
import { NavLink } from "reactstrap";
import { Maximize, Minimize } from "react-feather";
import LoadingComponent from "../lodingComponent";
import SLD from "./SLD";
import React from "react";

import { off } from "process";
import { on } from "rsuite/esm/DOMHelper";

const PumpingStationControl = () => {
  const [fullScreen, setFullScreen] = useState(false);
  const targetRef = useRef<HTMLDivElement | null>(null); 
  const [isOpen, setIsOpen] = useState(false);
  const [EOPDOpen, setEOPDOPEN] = useState(false);
  const [sumopen, setsumsopen] = useState(false);
  const [motoropen, setmotorsopen] = useState(false);
  const [dischargeopen, setdischargeopen] = useState(false);
  const [vaccumOpen, setVaccumOpen] = useState(false);
  const [selectedPump, setSelectedPump] = useState<string | null>(null);
  const [valveOpen, setValveOpen] = useState(false);
  const [selectedValve, setSelectedValve] = useState<string | null>(null);
  const [motorOpen, setMotorOpen] = useState(false);
  const [selectedMotor, setSelectedMotor] = useState<string | null>(null);
  const[loading,setloading] = useState<Boolean>(true)
  const dopen = () => setdischargeopen(true);
  const dclose = () => setdischargeopen(false);



  const mopen = () => setmotorsopen(true);
  const mclose = () => setmotorsopen(false);

  const sopen = () => setsumsopen(true);
  const sclose = () => setsumsopen(false);
  const eopen = () => setEOPDOPEN(true);
  const eclose = () => setEOPDOPEN(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);


  const [PumpData, setpumpdata] = useState<any[]>([]);
  const getAllPumpingStations = async () => {
    try {
      const response = await ApiService.axiosApi(`/tags`, {
        method: "GET",
      });

      if (response.success) {
        
        setpumpdata(response.data);
        setloading(false)
        
      } else {
        console.error("Failed to fetch pumping stations");
      }
    } catch (error) {
      console.error("Error fetching pumping stations:", error);
      console.log("Error fetching pumping stations");
    }
  };

 
useEffect(() => {
  getAllPumpingStations();

  // Move setInterval inside useEffect
  const interval = setInterval(() => {
    getAllPumpingStations();
  }, 5000); 

  // Cleanup interval on unmount
  return () => clearInterval(interval);
}, []); // keep dependency array


  const openVaccum = (pumpName: string) => {
    setSelectedPump(pumpName);
    setVaccumOpen(true);
  };

  const closeVaccum = () => setVaccumOpen(false);

  const openValve = (valveName: string) => {
    setSelectedValve(valveName);
    setValveOpen(true);
  };

  const closeValve = () => setValveOpen(false);

  const openMotor = (motorName: string) => {
    setSelectedMotor(motorName);
    console.log(motorName)
    setMotorOpen(true);
  };

  const closeMotor = () => setMotorOpen(false);

  const fullScreenHandler = async () => {
    try {
      if (!fullScreen) {
        if (targetRef.current && targetRef.current.requestFullscreen) {
          await targetRef.current.requestFullscreen();
        }
      } else {
        if (document.fullscreenElement && document.exitFullscreen) {
          await document.exitFullscreen();
        }
      }
    } catch (err) {
      console.error("Fullscreen error:", err);
    }
  };

  useEffect(() => {
    const handleFullScreenChange = () => {
      setFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullScreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullScreenChange);
  }, []);


 

  return (
    <>
   
   {loading?  <LoadingComponent/> :<>  <div ref={targetRef} className="pump-structure-wrapper">



            <li
              style={{
                position: "absolute",
                top: "4.2%",
                left: "3%",
                listStyle: "none",
                      height: "30px",
                width: "30px",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                transition: "all 0.2s ease-in-out",
                padding: 0,
              zIndex:1000
              }}
        className="min-max-station-control"
              onClick={fullScreenHandler}
            >
              {fullScreen ? <Minimize size={18} /> : <Maximize size={18} />}
            </li>

        <div className="img-wrapper-pump">
          
          <img src={structure} loading="lazy" className="pump-control-img" />
        </div>

        {["EOPD1", "EOPD2", "EOPD3", "EOPD4", "EOPD5"].map((valveName, idx) => {
          // Get the relevant tags for this pump
          const tags: { Name: string; value: string }[] = PumpData.filter(
            (t: { name: string; value: string }) => t.name.startsWith(valveName)
          );

          const onTag = tags.find((t: any) => t.name === `${valveName}_OPN`);
          const offTag = tags.find((t: any) => t.name === `${valveName}_CLS`);
          const anyFaultTag = tags.find(
            (t: any) => t.name === `${valveName}_ANYFLT`
          );
          // Determine which image to show
          let imgSrc =
            onTag?.value === "True" &&
            offTag?.value === "False" &&
            anyFaultTag?.value === "False"
              ? MBFV03
              : onTag?.value === "False" &&
                offTag?.value === "True" &&
                anyFaultTag?.value === "False"
              ? MBFV01
              : anyFaultTag?.value === "True"
              ? YellowValveImg
              : onTag?.value === "False" &&
                offTag?.value === "False" &&
                anyFaultTag?.value === "False"
              ? GreyValveImg
              : MBFV01; 
          let label = "";
          let color = "";
          if (imgSrc === MBFV03) {
            label = "OPEN";
            color = "yellowgreen";
          } else if (imgSrc === MBFV01) {
            label = "CLOSE";
            color = "red";
          } else if (imgSrc === YellowValveImg) {
            label = "FAULT";
            color = "gold";
          }else if (imgSrc === GreyValveImg) {
            label = "UNKNOWN";
            color = "black";
          }

          // Calculate left position for each pump dynamically
          const leftPositions = ["39%", "45.4%", "52.1%", "58.6%", "65%"];

          return (
            <div>
              <span
                style={{
                  color: color,
                  fontWeight: "bold",
                  display: "block",
                 fontSize: "clamp(1px, 0.7vw, 15px)",
                  marginBottom: "2px",
                  position: "absolute",
                  top: "38.2%", // adjust so label is above the image
                  left: leftPositions[idx],
                  transform: "translateX(-50%)", // center the label horizontally
                  zIndex: 10, // ensure label is above the image
                }}
              >
                {label}
              </span>

              <img
                key={valveName}
                src={imgSrc ? imgSrc : MBFV01}
                alt={valveName}
                loading="lazy"
                style={{
                  left: leftPositions[idx],
                  position: "absolute",
                  cursor: "pointer",
                  objectFit: "contain",

                  // 👇 conditional width for each image type
                  width:
                    imgSrc === YellowValveImg
                      ? "4%" // yellow
                      : imgSrc === MBFV03
                      ? "4%" // ON (green)
                      : imgSrc === MBFV01
                      ? "4.5%" // OFF (red)
                       : imgSrc=== GreyValveImg //
                      ? "4.2%"
                      : undefined, //

                  // 👇 conditional height for each image type
                  height:
                    imgSrc === YellowValveImg
                      ? "6%" // yellow
                      : imgSrc === MBFV03
                      ? "4.9%" // ON (green)
                      : imgSrc === MBFV01
                      ? "6.2%" // OFF (red)
                      : imgSrc=== GreyValveImg //
                      ? "4.4%"
                      :undefined,
                  // 👇 conditional top positioning
                  top:
                    imgSrc === YellowValveImg
                      ? "39%" // yellow
                      : imgSrc === MBFV03
                      ? "40%" // ON (green)
                      : imgSrc === MBFV01
                      ? "39.3%" // OFF (red)
                       : imgSrc=== GreyValveImg //
                      ? "39.5%"
                      : undefined, //
                }}
                onClick={() => openValve(valveName)} // open motor modal
              />
            </div>
          );
        })}

        <EOPD
          isOpen={valveOpen}
          onClose={closeValve}
          valveName={selectedValve || "EOPD1_CLS"}
           container={targetRef.current}
        />

        {["VAC_PMP1", "VAC_PMP2"].map((vacccumPumpName) => {
          // Get the relevant tags for this valve
          const tags: { name: string; value: string }[] = PumpData.filter(
            (t: { name: string; value: string }) =>
              t.name.startsWith(vacccumPumpName)
          );
         
          const ON = tags.find((t: any) => t.name === `${vacccumPumpName}_ON`);
          const OFF = tags.find(
            (t: any) => t.name === `${vacccumPumpName}_OFF`
          );
          const ANYFLT = tags.find(
            (t: any) => t.name === `${vacccumPumpName}_ANYFLT`
          );

          const imgSrc =
            ON?.value === "True" &&
            OFF?.value === "False" &&
            ANYFLT?.value === "False"
              ? psGreen
              : ON?.value === "False" &&
                OFF?.value === "True" &&
                ANYFLT?.value === "False"
              ? PS101
              : ANYFLT?.value === "True"
              ? psYellow
              : ON?.value === "False" &&
                OFF?.value === "False" &&
                ANYFLT?.value === "False"
              ? psGrey
              : PS101; // default gray state

          let label = "";
          let color = "";
          if (imgSrc === psGreen) {
            label = "OPEN";
            color = "yellowgreen";
          } else if (imgSrc === PS101) {
            label = "CLOSE";
            color = "red";
          } else if (imgSrc === psYellow) {
            label = "FAULT";
            color = "gold";
          }else if (imgSrc === psGrey) {
            label = "UNKNOWN";
            color = "BLACK";
          }

          // Define valve positions and CSS (same as your upper div)
          const valveStyle: React.CSSProperties[] = [
            {
              position: "absolute",
              top: "79.9%",
              left: "34.3%",
              height: "5%",
              width: "3.5%",
              cursor: "pointer", 
              //  userSelect: "none",  
            },
            {
              position: "absolute",
              top: "85%",
              left: "34.2%",
              height: "5%",
              width: "3.5%",
              cursor: "pointer", 
              //  userSelect: "none",  
            },
          ];

          return (
            <div
              style={{
                ...(vacccumPumpName === "VAC_PMP1"
                  ? valveStyle[0]
                  : valveStyle[1]),
                textAlign: "center",
              }}
            >
              {/* Status Label */}
              <span
                style={{
                  color: color,
                  fontWeight: "bold",
                  display: "block",
                fontSize: "clamp(1px, 0.7vw, 15px)",
                  marginBottom: "2px",
                  position: "absolute",  cursor: "pointer", 
                    //  userSelect: "none",  

                  right: vacccumPumpName === "VAC_PMP1" ? "102%" : "102%", // different left for each valve
                  top: vacccumPumpName === "VAC_PMP1" ? "22%" : "30%", // different top for each valve
                }}
              >
                {label}
              </span>

              <img
               loading="lazy"
                key={vacccumPumpName}
                src={imgSrc ? imgSrc : PS101}
                alt={vacccumPumpName}
                style={{
                  width: "100%",
                  height: "100%",
                 cursor: "pointer", 
                }}
                onClick={() => openVaccum(vacccumPumpName)}
              />
            </div>
          );
        })}

        <VaccumPump
          isOpen={vaccumOpen}
          onClose={closeVaccum}
          pumpName={selectedPump || "VAC_PMP1_OFF"}
            container={targetRef.current} 
        />

        {["SOV1", "SOV2"].map((valveName) => {
          // Get the relevant tags for this valve
          const tags: { name: string; value: string }[] = PumpData.filter(
            (t: { name: string; value: string }) => t.name.startsWith(valveName)
          );
        

          const onTag = tags.find((t: any) => t.name === `${valveName}_STR`);
          const offTag = tags.find((t: any) => t.name === `${valveName}_STP`);

          // Determine which image to show

          const imgSrc =
            onTag?.value === "True" && offTag?.value === "False"
              ? SovGreen
              : onTag?.value === "False" && offTag?.value === "True"
              ? SovValve
              : SovValve; 

          let label = "";
          let color = "";
          if (imgSrc === SovGreen) {
            label = "OPEN";
            color = "yellowgreen";
          } else if (imgSrc === SovValve) {
            label = "CLOSE";
            color = "red";
          }

          // Define valve positions and CSS (same as your upper div)
          const valveStyles: React.CSSProperties[] = [
            {
              top: "55.9%",
              left: "26.2%",
              height: "6%",
              // width: "2.9%",
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            },
            {
              top: "65.5%",
              left: "26.2%",
              height: "6%",
              // width: "2.9%",
              position: "absolute",
              justifyContent: "center",
              alignItems: "center",
            },
          ];

          return (
            <div
              style={{
                ...(valveName === "SOV1" ? valveStyles[0] : valveStyles[1]),
                textAlign: "center",
                position: "absolute",
                display: "flex",
                flexDirection:
                  valveName === "SOV1" ? "column" : "column-reverse", // 🔥 dynamic layout
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Label */}
              <span
                style={{
                  color: color,
                  fontWeight: "bold",
                  marginBottom: valveName === "SOV1" ? "5px" : "0px",
                  marginTop: valveName === "SOV2" ? "5px" : "0px",
                   fontSize: "clamp(1px, 0.7vw, 15px)",
                }}
              >
                {label}
              </span>

              {/* Valve Image */}
              <img
              loading="lazy"
                key={valveName}
                src={imgSrc ? imgSrc : RedImage}
                alt={valveName}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
          );
        })}

        <span
          className="MBFV01-txt"
          style={{
            left: "36.6%",
            top: "36%",
            color: " white",
            width: "5%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "black",
            paddingTop: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          MBFV01
        </span>
        <span
          className="MBFV02-txt"
          style={{
            left: "43%",
            top: "36%",
            paddingTop: 2,
            color: " white",
            width: "5%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          MBFV02
        </span>
        <span
          className="MBFV03-txt"
          style={{
            left: "49.4%",
            top: "36%",
            paddingTop: 2,
            color: " white",
            width: "5%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          MBFV03
        </span>
        <span
          className="MBFV04-txt"
          style={{
            left: "56%",
            top: "36%",
            paddingTop: 2,
            color: " white",
            width: "5%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          MBFV04
        </span>
        <span
          className="MBFV05-txt"
          style={{
            left: "62.5%",
            top: "36%",
            paddingTop: 2,
            color: " white",
            width: "5%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          MBFV05
        </span>

        {PumpData.map((tag) => {
          return (
            <React.Fragment key={tag.Name}>
              

              <div
                className="MBFV1-open"
                style={{
                  top: "46%",
                  left: "36.6%",
                  width: "5%",
                  height: "2.5%",
                  fontSize: "clamp(1px, 0.7vw, 15px)",
                }}
              >
                {PumpData.find((tag) => tag.name === "EOPD1_POS")?.value ??
                  "Empty"}
                %
                <span
                  style={{
                    color: "rgba(0, 255, 55, 0.85)",
                    fontSize: "clamp(1px, 0.7vw, 15px)",
                  }}
                >
                  OPEN
                </span>
              </div>

              {/* MBFV2 → EOPD2_POS */}

              <div
                className="MBFV2-open"
                style={{
                  top: "46%",
                  left: "42.9%",
                  width: "5%",
                  height: "2.5%",
                  fontSize: "clamp(1px, 0.7vw, 15px)",
                }}
              >
                {PumpData.find((tag) => tag.name === "EOPD2_POS")?.value ??
                  "Empty"}
                %
                <span
                  style={{
                    color: "rgba(0, 255, 55, 0.85)",
                    fontSize: "clamp(1px, 0.7vw, 15px)",
                  }}
                >
                  OPEN
                </span>
              </div>

              {/* MBFV3 → EOPD3_POS */}

              <div
                className="MBFV3-open"
                style={{
                  top: "46%",
                  left: "49%",
                  width: "5.6%",
                  height: "2.5%",
                  fontSize: "clamp(1px, 0.7vw, 15px)",
                }}
              >
                {PumpData.find((tag) => tag.name === "EOPD3_POS")?.value ??
                  "Empty"}
                %
                <span
                  style={{
                    color: "rgba(0, 255, 55, 0.85)",
                    fontSize: "clamp(1px, 0.7vw, 15px)",
                  }}
                >
                  OPEN
                </span>
              </div>

              {/* MBFV4 → EOPD4_POS */}

              <div
                className="MBFV4-open"
                style={{
                  top: "46%",
                  left: "55.7%",
                  width: "5.5%",
                  height: "2.5%",
                  fontSize: "clamp(1px, 0.7vw, 15px)",
                }}
              >
                {PumpData.find((tag) => tag.name === "EOPD4_POS")?.value ??
                  "Empty"}
                %
                <span
                  style={{
                    color: "rgba(0, 255, 55, 0.85)",
                    fontSize: "clamp(1px, 0.7vw, 15px)",
                  }}
                >
                  OPEN
                </span>
              </div>

              {/* MBFV5 → EOPD5_POS */}

              <div
                className="MBFV5-open"
                style={{
                  top: "46%",
                  left: "62.2%",
                  width: "5.5%",
                  height: "2.5%",
                  fontSize: "clamp(1px, 0.7vw, 15px)",
                }}
              >
                {PumpData.find((tag) => tag.name === "EOPD5_POS")?.value ??
                  "Empty"}
                %
                <span
                  style={{
                    color: "rgba(0, 255, 55, 0.85)",
                    fontSize: "clamp(1px, 0.7vw, 15px)",
                  }}
                >
                  OPEN
                </span>
              </div>
            </React.Fragment>
          );
        })}

        <div
          className="PT-text1"
          style={{
             left: "35.8%",
            top: "52%",
            width: "6%",
            paddingLeft: "1.5%",

            backgroundColor: "black",
            fontSize: "clamp(1px, 0.7vw, 15px)",
          }}
        >
          PT-01
        </div>
        <div
          className="PT-text2"
          style={{
            left: "42.4%",
            top: "52%",
            width: "6%",
            paddingLeft: "1.5%",
            backgroundColor: "black",
            fontSize: "clamp(1px, 0.7vw, 15px)",
          }}
        >
          PT-02
        </div>
        <div
          className="PT-text3"
          style={{
           left: "48.9%",
            top: "52%",
            width: "6%",
            paddingLeft: "1.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "black",
          }}
        >
          PT-03
        </div>

        <div
          className="PT-text4"
          style={{
            left: "55.5%",
            top: "52%",
            width: "6%",
            paddingLeft: "2%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "black",
          }}
        >
          PT-04
        </div>
        <div
          className="PT-text5"
          style={{
            left: "62%",
            top: "52%",
            width: "6%",
            paddingLeft: "2%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "black",
          }}
        >
          PT-05
        </div>

        <div
          className="PT1-open"
          style={{
            top: "54%",
            left: "35.8%",
            width: "6%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "#495057",
          }}
        >
          <span style={{ fontSize: "85%", paddingLeft:"1%"}}>VALUE:</span>
          <span
            style={{
              color: "rgba(0, 255, 55, 0.85)",
              fontSize: "clamp(1px, 0.7vw, 15px)",
            }}
          >
            {PumpData.find((tag) => tag.name === "PMP1_PT_VAL")?.value ?? "0"}
            bar
          </span>
        </div>

        <div
          className="PT2-open"
          style={{
            top: "54%",
            left: "42.4%",
            width: "6%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "#495057",
          }}
        >
          <span style={{ fontSize: "85%" }}>VALUE:</span>
          <span
            style={{
              color: "rgba(0, 255, 55, 0.85)",
              fontSize: "clamp(1px, 0.7vw, 15px)",
            }}
          >
            {PumpData.find((tag) => tag.name === "PMP2_PT_VAL")?.value ?? "0"}
            bar
          </span>
        </div>

        <div
          className="PT3-open"
          style={{
            top: "54%",
            left: "48.9%",
            width: "6%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "#495057",
          }}
        >
          <span style={{ fontSize: "85%" }}>VALUE:</span>
          <span
            style={{
              color: "rgba(0, 255, 55, 0.85)",
              fontSize: "clamp(1px, 0.7vw, 15px)",
            }}
          >
            {PumpData.find((tag) => tag.name === "PMP3_PT_VAL")?.value ?? "0"}
            bar
          </span>
        </div>

        <div
          className="PT4-open"
          style={{
            top: "54%",
            left: "55.5%",
            width: "6%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "#495057",
          }}
        >
          <span style={{ fontSize: "85%" }}>VALUE:</span>
          <span
            style={{
              color: "rgba(0, 255, 55, 0.85)",
              fontSize: "clamp(1px, 0.7vw, 15px)",
            }}
          >
            {PumpData.find((tag) => tag.name === "PMP4_PT_VAL")?.value ?? "0"}
            bar
          </span>
        </div>

        <div
          className="PT5-open"
          style={{
            top: "54%",
            left: "62%",
            width: "6%",
            height: "2.5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            backgroundColor: "#495057",
          }}
        >
          <span style={{ fontSize: "85%" }}>VALUE:</span>
          <span
            style={{
              color: "rgba(0, 255, 55, 0.85)",
              fontSize: "clamp(1px, 0.7vw, 15px)",
            }}
          >
            {PumpData.find((tag) => tag.name === "PMP5_PT_VAL")?.value ?? "0"}
            bar
          </span>
        </div>

        <div
          className="Pump1-txt"
          style={{
            left: "42%",
            top: "81%",
            height: "2.8%",
            // width: "5%",
            fontSize: "clamp(1px, 0.7vw, 15px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // paddingTop: 2,
          }}
        >
          PUMP-01
        </div>
        <div
          className="Pump2-txt"
          style={{
            left: "49%",
            top: "81%",
            height: "2.8%",
            // width: "5%",
            // paddingTop: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "clamp(1px, 0.7vw, 15px)",
          }}
        >
          PUMP-02
        </div>
        <div
          className="Pump3-txt"
          style={{
            left: "56%",
            top: "81%",
            height: "2.8%",
            // width: "5%",
            // paddingTop: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "clamp(1px, 0.7vw, 15px)",
          }}
        >
          PUMP-03
        </div>
        <div
          className="Pump4-txt"
          style={{
            left: "63%",
            top: "81%",
            height: "2.8%",
            // width: "5%",
            // paddingTop: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "clamp(1px, 0.7vw, 15px)",
          }}
        >
          PUMP-04
        </div>
        <div
          className="Pump5-txt"
          style={{
            left: "70%",
            top: "81%",
            height: "2.8%",
            // width: "5%",
            // paddingTop: 2,
            fontSize: "clamp(1px, 0.7vw, 15px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          PUMP-05
        </div>

        <div
          className="dischargeLine"
          style={{
            top: "10%",
            left: "51%",
            height: "3.5%",
            width: "12%",
            fontSize: "clamp(2px, 0.8vw, 14px)",
            cursor: "pointer",
          }}
          onClick={dopen}
        >
          DISCHARGE LINE PT
        </div>

        {["MAIN_HL_PT_VAL"].map((tagName) => {
          // Find the pressure tag in PumpData
          const tag = PumpData?.find(
            (t: { name: string; value: string }) => t.name === tagName
          );
          const pressureValue = tag ? tag?.value : "null";
          

          return (
            <div
              className="Pressure-pump-control"
              style={{
                top: "13.4%",
                left: "51%",
                height: "3.5%",
                width: "12%",
                fontSize: "clamp(2px, 0.8vw, 14px)",
              }}
            >
              PRESSURE:{" "}
              <span className="valuePressure">{pressureValue}bar</span>
            </div>
          );
        })}

        <DischargeLine isOpen={dischargeopen} onClose={dclose}   container={targetRef.current}/>

        <div
          className="LastResponseTime"
          style={{
            left: "85%",
            height: "4%",
            width: "15%",
            top: "3%",
            fontSize: "clamp(2px, 0.8vw, 14px)",
            cursor: "pointer",
          }}
        >
          LAST RESPONSE TIME{" "}
        </div>

         {PumpData.map((LatestTimestamp) => {
        
          return (
            <div
              key={LatestTimestamp.id} // unique key
              className="Time"
              style={{
                left: "85%",
                height: "4%",
                width: "15%",
                fontSize: "clamp(2px, 0.8vw, 13px)",
                paddingLeft: "2%",
              }}
            >
              
              <span className="valueTime" style ={{fontSize: "clamp(1px, 0.7vw, 12px)", 
             }}><span style={{color:'white'}}>TIME:{" "}</span>{LatestTimestamp?.latestTimestamp? LatestTimestamp.latestTimestamp.replace("T", " ") : "null"}

              </span>
            </div>
          );
        })} 


  



        <div
          className="intakesumpump"
          style={{
            top: "55%",
            left: "76.9%",
            height: "3.5%",
            width: "11.2%",
            fontSize: "clamp(3px, 0.8vw, 14px)",
            cursor: "pointer",
          }}
          onClick={sopen}
        >
          INTAKE SUMP
        </div>

       
          <div
            className="intakesumpump-control"
            style={{
              top: "58.5%",
              left: "76.9%",

              height: "3.5%",
              width: "11.2%",
              fontSize: "clamp(3px, 0.8vw, 14px)",
            }}
          >
            LEVEL:
            <span style={{ color: "rgba(0, 255, 55, 0.85)" }}>
              {PumpData.find((tag) => tag.name === "SUMP_LVL_VAL")?.value ??
                0}m
            </span>
          </div>
        

        <IntakeSum isOpen={sumopen} onClose={sclose}
         container={targetRef.current} />

       
          <div className="dischargeLineFlow" >
            <div
              id="dsflowtxt1"
              style={{
                left: "64%",
                top: "10%",
                width: "12.9%",
                height: "3.5%",
                fontSize: "clamp(2px, 0.8vw, 13px)",
              }}
            >
              <div>
                FLOW RATE:
                <span className="valueFlow1">
                  {" "}
                  {PumpData.find((t) => t.name === "MAIN_HL_FT_VAL")?.value ??
                    "0"} kg/cm
                </span>
              </div>
            </div>
          </div>
      

        
          <div
            id="dsflowtxt2"
            style={{
              left: "64%",
              top: "13%",
              width: "12.9%",
              height: "3.5%",
              fontSize: "clamp(1px, 0.8vw, 12px)",
         
               
       
            }}
          >
            <div>
              TODAY'S VOLUME:
              
              <span className="valueFlow2">
                 {" "}
                {PumpData.find((t) => t.name === "MAIN_HL_FT_VOL")?.value ??
                  0}m³
              </span>
            </div>
          </div>
      

        <div
          className="preFiltration-text"
          onClick={openModal}
          style={{
  position: "absolute",
  top: "24%",
  left: "61.5%",
  width: "7%",
  height: "6%",
  fontSize: "clamp(1px, 0.7vw, 10px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: '10px'
}}

        >
          PRE FILTERATION SYSTEM
        </div>

        <Filtration isOpen={isOpen} onClose={closeModal} container={targetRef.current}/>
        <div
          className="bl-text"
          style={{
            top: "13.2%",
            left: "77.3%",
            fontSize: "clamp(1px, 0.7vw, 10px)",
            height: "10%",
            width: "4.3%",
            cursor: "pointer",
          }}
        >
          BLADDER VESSEL
        </div>

        <div className="VP-txt1">
          <span
            style={{
              left: "37.5%",
              top: "82%",
              // width: "4%",
              height: "2%",
              fontSize: "clamp(1px, 0.7vw, 15px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            VP-01
          </span>
        </div>

        <div className="VP-txt2">
          <span
            style={{
              left: "37.5%",
              top: "87%",
              // width: "4%",
              height: "2%",
              fontSize: "clamp(1px, 0.7vw, 15px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            VP-02
          </span>
        </div>

        <div className="">
          <span
            style={{
              top: "65%",
              left: "30%",
              height: "2%",
              // width: "3%",
              fontSize: "clamp(3px, 0.8vw, 14px)",
              backgroundColor: "black",
              position: "absolute",
              color: "white",
              paddingLeft: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            SOV-2
          </span>
        </div>
        <div className="SOV-txt1">
          <span
            style={{
              top: "58%",
              left: "30%",
              height: "2%",
              // width: "3%",
              backgroundColor: "black",
              position: "absolute",
              color: "white",
              fontSize: "clamp(3px, 0.8vw, 14px)",
              paddingLeft: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            SOV-1
          </span>
        </div>

        <div className="IntakeCannal">
          <span
            style={{
              left: "13%",
              top: "80%",
              width: "8.1%",
              height: "2.5%",
              fontSize: "clamp(3px, 0.8vw, 14px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            INTAKECANNAL
          </span>
        </div>

        
          <div
            className="BVload"
            style={{
              left: "86%",
              top: "18%",
              width: "8%",
              height: "3%",
              fontSize: "clamp(3px, 0.7vw, 14px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="BVloadvalue">
              {PumpData.find((t) => t.name === "BLD_VSL_LC")?.value ?? 0}Ton
            </span>
          </div>
        

       
          <div
            className="BVpt"
            style={{
              left: "86%",
              top: "22%",
              width: "8%",
              height: "3%",
              fontSize: "clamp(3px, 0.7vw, 14px)",
            }}
          >
            <span className="BVptvalue">
              {PumpData.find((t) => t.name === "BLD_VSL_PT")?.value ?? 0}Bar
            </span>
          </div>
      

        <div className="Ps-txt1">
          <span
            style={{
              left: "31.5%",
              top: "79%",
              // width: "2.2%",
              height: "1.6%",
              backgroundColor: "black",
               fontSize: "clamp(1px, 0.7vw, 10px)",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="Ps-txt1value"
          >
            PS-101
          </span>
        </div>

        <div className="Ps-txt2">
          <span
            style={{
              left: "31.5%",
              top: "85%",
              // width: "2.2%",
              height: "1.6%",
              fontSize: "clamp(1px, 0.7vw, 10px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="Ps-txt2value"
          >
            PS-102
          </span>
        </div>

        <div className="grey_lvl">
          <span className="grey_lvlvalue"></span>
        </div>

       {PumpData.filter((tag) => tag.name === "SUMP_LVL_VAL").map((tag) => {
  const waterLevel = tag.value ?? 0;
  const maxLevel = 10;
  const maxHeightPercent = 20;
  const heightPercentage = ((waterLevel * maxHeightPercent) / 100) * 10;
  
  return (
    <div
      key={tag.id}
      style={{
        height: `${heightPercentage}%`,
        width: "37.5%",
        backgroundColor: "#2aafd1",
        opacity: "0.5",
        position: "absolute",
        left: "37.5%",
        transition: "height 0.3s ease",
        zIndex: 120,
        bottom: "20.4%",
      }}
    />
  );
})}
<div
  className="water-pump-control"
  style={{
    height: "20%",
    width: "37.5%",
    top: "59.5%",
    left: "37.5%",
    cursor: "pointer",
    position: "absolute",
    zIndex: 100,
    overflow: "hidden",
  }}
>
  <div
    className="water-scale"
    style={{
      position: "absolute",
     left: "clamp(0.2%, 1%, 1.5%)",
      bottom: 0,
      top: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      height: "100%",
      width: "clamp(25px, 4vw, 45px)", // Responsive width
      fontSize: "clamp(0.3rem, 0.5vw + 0.1rem, 0.65rem)", // Responsive font
      fontWeight: 900,
      zIndex: 2000,
      color: "#000",
      pointerEvents: "none",
      padding: "clamp(0.5px, 0.2vh, 2px) 0", // Responsive padding
    }}
  >
    {Array.from({ length: 21 }, (_, i) => {
      const value = 10 - i * 0.5;
      const isWhole = Number.isInteger(value);

      return (
        <div
          key={value}
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "auto",
            flex: "0 0 auto",
          }}
        >
          <div
            style={{
              width: isWhole 
                ? "clamp(5px, 0.8vw + 0.2vh, 10px)" 
                : "clamp(3px, 0.5vw + 0.1vh, 6px)",
              height: isWhole 
                ? "clamp(1px, 0.15vw + 0.1vh, 2px)" 
                : "clamp(0.5px, 0.1vw + 0.05vh, 1.5px)",
              backgroundColor: "#000",
              marginRight: "clamp(1px, 0.3vw + 0.1vh, 3px)",
              opacity: isWhole ? 1 : 0.6,
              flexShrink: 0,
            }}
          ></div>

          {isWhole && (
            <span 
              style={{ 
                whiteSpace: "nowrap",
                lineHeight: "clamp(0.8, 0.9, 1)", // Responsive line height
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "calc(100% - clamp(8px, 1.5vw, 15px))", // Prevent text overflow
              }}
            >
              {value}m
            </span>
          )}
        </div>
      );
    })}
  </div>
</div>

        <div
          style={{
            // 50% of parent container's height
            width: "7.2%", // 80% of parent container's width
            border: "2px solid black",
            position: "absolute",
            top: "23%",
            left: "79%",
          }}
        ></div>

        <div
          style={{
            width: "5%",
            border: "2px solid black",
            position: "absolute",
            top: "19.2%",
            left: "81.2%",
          }}
        ></div>

        <div
          style={{
            // 50% of parent container's height
            height: "6.2%", // 80% of parent container's width
            border: "2px solid black",
            position: "absolute",
            top: "16.9%",
            left: "57%",
          }}
        ></div>

        <div
          style={{
            height: "6.6%",
            border: "2px solid black",
            position: "absolute",
            top: "16.5%",
            left: "73.6%",
          }}
        ></div>

        <div>
          {["PMP1", "PMP2", "PMP3", "PMP4", "PMP5"].map((motorName, idx) => {
            // Get the relevant tags for this pump
            const tags: { Name: string; value: string }[] = PumpData.filter(
              (t: { name: string; value: string }) =>
                t.name.startsWith(motorName)
            );

            const onTag = tags.find((t: any) => t.name === `${motorName}_ON`);
            const offTag = tags.find((t: any) => t.name === `${motorName}_OFF`);
           
            const anyFaultTag = tags.find(
              (t: any) => t.name === `${motorName}_ANYFLT`
            );
            // Determine which image to show

            let imgSrc =
              onTag?.value === "True" &&
              offTag?.value === "False" &&
              anyFaultTag?.value === "False"
                ? GreenImage
                : onTag?.value === "False" &&
                  offTag?.value === "True" &&
                  anyFaultTag?.value === "False"
                ? RedImage
                : anyFaultTag?.value === "True"
                ? YellowImage
                : onTag?.value === "False" &&
                  offTag?.value === "False" &&
                  anyFaultTag?.value === "False"
                ? GreyImage // if all are false
                : RedImage; // default fallback

            let label = "";
            let color = "";
            if (imgSrc === GreenImage) {
              label = "ON";
              color = "green";
            } else if (imgSrc === RedImage) {
              label = "OFF";
              color = "red";
            } else if (imgSrc === YellowImage) {
              label = "FAULT";
              color = "gold";
            }else if (imgSrc === GreyImage) {
            label = "UNKNOWN";
            color = "black";
          }


            // Calculate left position for each pump dynamically
            const leftPositions = ["45%", "51.4%", "58.1%", "64.6%", "71%"];

            return (
              <div
                key={motorName}
                style={{
                  position: "absolute",
                  top: "72%",
                  left: leftPositions[idx],
                  textAlign: "center",
                  transform: "translateX(-50%)",
                  width: "5%", // match image width,
                  zIndex: 1000,
                }}
              >
                {/* Label above image */}
                <span
                  style={{
                    color: color,
                    fontWeight: "bold",
                    marginBottom: "5px",
                    display: "block",
                      fontSize: "clamp(1px, 0.7vw, 15px)",
                    zIndex: 500,
                  }}
                >
                  {label}
                </span>

                {/* Pump image */}
                <img
                  src={imgSrc}
                  alt={motorName}
                  style={{
                    width: "100%", // ensures it fits the div width
                    cursor: "pointer",
                  }}
                  onClick={() => openMotor(motorName)} // open motor modal
                />
              </div>
            );
          })}

          <Motor
            isOpen={motorOpen}
            onClose={closeMotor}
            motorName={selectedMotor || "PMP1_OFF"}
            container={targetRef.current} // default if null
          />
        </div>
           <div>
  <div className="Lvl1"
  style={{
   position:'absolute',
     height: '3%',
    width:'2%',
    backgroundColor:
      PumpData.find(t => t.name === 'SUMP_LVL_HH' && t.value === 'True')
        ? 'green'
        : '#444',
  }}></div>
  <span className="lvl1txt"style={{ fontSize: "clamp(1px, 0.7vw, 10px)", fontWeight: "bold",    left: '77.5%',
    top: '65.6%',
    height: '2%',
    width: '1%'}}>HH</span>
</div>
<div>
  <div className="Lvl2"
  style={{
     position:'absolute',
   height: '3%',
    width:'2%',
    backgroundColor:
      PumpData.find(t => t.name === 'SUMP_LVL_H' && t.value === 'True')
        ? 'green'
        : '#444',
  }}></div>
  <span className="lvl2txt"style={{ fontSize: "clamp(1px, 0.7vw, 10px)", fontWeight: "bold",    left: '77.7%',
    top: '70.6%', height: '2%',
    width: '1%'}}>H</span>
</div>

<div>
  <div className="Lvl3"
  style={{
     position:'absolute',
    height: '3%',
    width:'2%',
    backgroundColor:
      PumpData.find(t => t.name === 'SUMP_LVL_L' && t.value === 'True')
        ? '#DD0303'
        : '#444',
  }}></div>
  <span className="lvl3txt"style={{ fontSize: "clamp(1px, 0.7vw, 10px)", fontWeight: "bold",left: '77.8%',
    top: '74.5%', height: '2%',
    width: '1%'}}>L</span>
</div>


<div>
  <div className="Lvl4"
  style={{
      position:'absolute',
    height: '3%',
    width:'2%',
    backgroundColor:
      PumpData.find(t => t.name === 'SUMP_LVL_LLS' && t.value === 'True')
        ? '#DD0303'
        : '#444',
  }}></div>
  <span className="lvl4txt" style={{ fontSize: "clamp(1px, 0.7vw, 10px)", fontWeight: "bold", height: '2%',
    width: '1%',left: '77.6%',
    top: '78.7%'}}>LLS</span>
</div>
      </div>
     
</>
}
    </>
  );
};


export default PumpingStationControl;

